module.exports = __webpack_public_path__ + "static/Vendor-4680c73407fdf2ae480fb24eebbf8636.png";